import { render, staticRenderFns } from "./ModalPage.vue?vue&type=template&id=55de0fcd&scoped=true&"
import script from "./ModalPage.vue?vue&type=script&lang=js&"
export * from "./ModalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de0fcd",
  null
  
)

export default component.exports